"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
// TODO since node 10 URL is global
var url_1 = require("url");
var node_fetch_1 = __importDefault(require("node-fetch"));
var config = __importStar(require("./config"));
var nylas_connection_1 = __importDefault(require("./nylas-connection"));
var management_account_1 = __importDefault(require("./models/management-account"));
var account_1 = __importDefault(require("./models/account"));
var connect_1 = __importDefault(require("./models/connect"));
var restful_model_collection_1 = __importDefault(require("./models/restful-model-collection"));
var management_model_collection_1 = __importDefault(require("./models/management-model-collection"));
var webhook_1 = __importDefault(require("./models/webhook"));
var access_token_1 = __importDefault(require("./models/access-token"));
var application_details_1 = __importDefault(require("./models/application-details"));
var Nylas = /** @class */ (function () {
    function Nylas() {
    }
    Object.defineProperty(Nylas, "clientSecret", {
        get: function () {
            return config.clientSecret;
        },
        set: function (newClientSecret) {
            config.setClientSecret(newClientSecret);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Nylas, "apiServer", {
        get: function () {
            return config.apiServer;
        },
        set: function (newApiServer) {
            config.setApiServer(newApiServer);
        },
        enumerable: true,
        configurable: true
    });
    Nylas.config = function (config) {
        if (config.apiServer && config.apiServer.indexOf('://') === -1) {
            throw new Error('Please specify a fully qualified URL for the API Server.');
        }
        if (config.clientId) {
            this.clientId = config.clientId;
        }
        if (config.clientSecret) {
            this.clientSecret = config.clientSecret;
        }
        if (config.apiServer) {
            this.apiServer = config.apiServer;
        }
        else {
            this.apiServer = 'https://api.nylas.com';
        }
        var conn = new nylas_connection_1.default(this.clientSecret, {
            clientId: this.clientId,
        });
        this.connect = new connect_1.default(conn, this.clientId, this.clientSecret);
        this.webhooks = new management_model_collection_1.default(webhook_1.default, conn, this.clientId);
        if (this.clientCredentials()) {
            this.accounts = new management_model_collection_1.default(management_account_1.default, conn, this.clientId);
        }
        else {
            this.accounts = new restful_model_collection_1.default(account_1.default, conn);
        }
        return this;
    };
    Nylas.clientCredentials = function () {
        return this.clientId != null && this.clientSecret != null;
    };
    Nylas.with = function (accessToken) {
        if (!accessToken) {
            throw new Error('This function requires an access token');
        }
        return new nylas_connection_1.default(accessToken, { clientId: this.clientId });
    };
    Nylas.application = function (options) {
        if (!this.clientId) {
            throw new Error('This function requires a clientId');
        }
        if (!this.clientSecret) {
            throw new Error('This function requires a clientSecret');
        }
        var connection = new nylas_connection_1.default(null, { clientId: this.clientId });
        var requestOptions = {
            path: "/a/" + this.clientId,
        };
        if (options) {
            requestOptions.body = {
                application_name: options.applicationName,
                icon_url: options.iconUrl,
                redirect_uris: options.redirectUris,
            };
            requestOptions.method = 'PUT';
        }
        return connection.request(requestOptions).then(function (res) {
            return new application_details_1.default().fromJSON(res);
        });
    };
    Nylas.exchangeCodeForToken = function (code, callback) {
        if (!this.clientId || !this.clientSecret) {
            throw new Error('exchangeCodeForToken() cannot be called until you provide a clientId and secret via config()');
        }
        if (!code) {
            throw new Error('exchangeCodeForToken() must be called with a code');
        }
        var url = new url_1.URL(this.apiServer + "/oauth/token");
        url.searchParams.set('client_id', this.clientId);
        url.searchParams.set('client_secret', this.clientSecret);
        url.searchParams.set('grant_type', 'authorization_code');
        url.searchParams.set('code', code);
        return node_fetch_1.default(url)
            .then(function (response) {
            if (response.ok) {
                return response.json();
            }
        })
            .then(function (body) {
            if (!body || !body['access_token']) {
                var errorMessage = 'No access token in response';
                if (body && body.message)
                    errorMessage = body.message;
                throw new Error(errorMessage);
            }
            if (callback) {
                callback(null, body);
            }
            return new access_token_1.default().fromJSON(body);
        }, function (error) {
            var newError = new Error(error.message);
            if (callback) {
                callback(newError);
            }
            throw newError;
        });
    };
    Nylas.urlForAuthentication = function (options) {
        if (!this.clientId) {
            throw new Error('urlForAuthentication() cannot be called until you provide a clientId via config()');
        }
        if (!options.redirectURI) {
            throw new Error('urlForAuthentication() requires options.redirectURI');
        }
        if (!options.loginHint) {
            options.loginHint = '';
        }
        var url = this.apiServer + "/oauth/authorize?client_id=" + this.clientId + "&response_type=code&login_hint=" + options.loginHint + "&redirect_uri=" + options.redirectURI;
        if (options.state != null) {
            url += "&state=" + options.state;
        }
        if (options.scopes != null) {
            url += "&scopes=" + options.scopes.join(',');
        }
        if (options.provider != null) {
            url += "&provider=" + options.provider;
        }
        if (options.redirectOnError) {
            url += '&redirect_on_error=true';
        }
        return url;
    };
    /**
     * Revoke a single access token
     * @param accessToken The access token to revoke
     */
    Nylas.revoke = function (accessToken) {
        return Nylas.with(accessToken)
            .request({
            method: 'POST',
            path: '/oauth/revoke',
        })
            .catch(function (err) { return Promise.reject(err); });
    };
    Nylas.clientId = '';
    return Nylas;
}());
module.exports = Nylas;
